<template>
  <service-category>

    <layout-header-title slot="header" title="와인스토어 정책"/>

    <div class="category" slot="category">

      <layout-two-column title="노쇼 기간">

        <layout-input v-model="editable.wpNoshowLimitDays"
                      type="number"
                      width="300px"
                      class="input"
                      :regex="regex(0, 100).num"/>  <span class="unit-text">일</span>

      </layout-two-column>

      <p class="info">노쇼 기간은 숫자 1당 1일 입니다. ex) 1 (1일)</p>

      <div class="multi-input-layout-wrapper">

        <p class="title">주문/취소 마감 시간</p>

        <div class="multi-input-layout">

          <div v-for="(obj, index) in editable.wpCutoffHourList"
               class="divided-input-wrapper"
               :key="index">

            <layout-divided-input v-model="editable.wpCutoffHourList[index]"
                                  first-name="order_cutoff_hour"
                                  last-name="cancel_cutoff_hour"/>

            <button class="btn-delete" @click="deleteWpCutoffItem(index)">삭제</button>

          </div>

          <button class="btn-add" @click="addWpCutoffItem">추가</button>

        </div>

      </div>

      <p class="info">마감되는 시간을 입력해주세요 ex) 밤 12시 = 24시</p>

    </div>

  </service-category>
</template>

<script>
import { regex } from '@/utils/utils';

import LayoutHeaderTitle from '@/spa/components/LayoutHeaderTitle';
import LayoutInput from '@/spa/components/LayoutInput';
import LayoutDividedInput from '@/spa/components/LayoutDividedInput';

import LayoutTwoColumn from '../LayoutTwoColumn';
import ServiceCategory from '../ServiceCategory';

export default {
  name: 'WinestorePolicy',
  props: {
    wpNoshowLimitDays: Number,
    wpCutoffHourList: Array,
  },
  components: {
    ServiceCategory,

    LayoutTwoColumn,
    LayoutHeaderTitle,
    LayoutInput,
    LayoutDividedInput,
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },

    addWpCutoffItem() {
      this.editable.wpCutoffHourList.push({ order_cutoff_hour: 0, cancel_cutoff_hour: 0 });
    },

    deleteWpCutoffItem(index) {
      this.editable.wpCutoffHourList.splice(index, 1);
    },
  },
  watch: {
    'editable.wpNoshowLimitDays': {
      deep: true,
      handler(value) {
        this.$emit('onChangeWpNoshowLimitDays', value);
      },
    },
    'editable.wpCutoffHourList': {
      deep: true,
      handler(value) {
        this.$emit('onChangeWpCutoffHourList', value);
      },
    },
  },
  data() {
    return {
      editable: {
        wpNoshowLimitDays: this.wpNoshowLimitDays,
        wpCutoffHourList: this.wpCutoffHourList || [],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.category {
  .info {
    text-align: left;
    margin-top: 6px;
    margin-left: 174px;
    font-size: 12px;
    color: #666;
  }

  .unit-text {
    display: inline-block;
    width: 40px;
    text-align: left;
    margin-left: 10px;

    padding: 0;
  }

  .input {
    width: 100%;
    min-width: 150px;
    max-width: 350px;
  }

  .multi-input-layout-wrapper:first-child {
    margin-top: 50px;
  }

  .multi-input-layout-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    flex-direction: row;

    margin-top: 20px;
    max-width: 540px;
    padding: 0 20px;
    box-sizing: border-box;

    .title {
      text-align: left;
      font-size: 15px;
      width: 150px;
      margin: 0;
      color: #666666;
    }

    .multi-input-layout {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .divided-input-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;

        .btn-delete {
          font-size: 12px;
          width: 40px;
          height: 28px;
          margin-left: 8px;
          border: none;
          border-radius: 24px;
          background-color: rgba(0,0,0,0.04);
          color: rgba(0,0,0,0.4);
          padding: 0;
        }
      }
      .btn-add {
        width: 100%;
        height: 36px;
        border: none;
        border-radius: 24px;
        background-color: rgba(0,0,0,0.04);
        color: rgba(0,0,0,0.4);
        padding: 0;
      }
    }
  }
}


@media screen and (max-width: 1024px) {
  .category {
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    .info {
      margin-left: 0;
      width: 80%;
      text-align: center;
    }

    .multi-input-layout-wrapper {
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;

      .title {
        margin-bottom: 24px;
      }

      .multi-input-layout {
        width: 100%;

        .divided-input-wrapper {
          width: 100%;

          .btn-delete {
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/category/WinestorePolicy.vue